// @ts-nocheck
import { useEffect, useState } from 'react';

export const getSignedUrl = async (src) => {
    if (!src) return null;
    const filename = fetchFileName(src);
    if (!filename) return "/fallback.jpg";
    const signEndpoint = `/api/sign-url/?filename=${encodeURIComponent(filename)}`;

    try {
        const res = await fetch(signEndpoint);

        if (!res.ok) return "/fallback.jpg";

        const contentType = res.headers.get("content-type") || "";

        // If signer responds with image bytes directly, use endpoint as src.
        if (!contentType.includes("application/json")) {
            return signEndpoint;
        }

        const data = await res.json();
        return data?.url || signEndpoint;
    } catch (err) {
        console.error("❌ Error in getSignedUrl:", err);
        return "/fallback.jpg";
    }
};

export const getSignedUrlForSEO = async (src: string, baseUrl: string) => {
    if (src) {
        const filename = fetchFileName(src);
        const fetchUrl = `${baseUrl}/api/seo-sign-url?filename=${encodeURIComponent(filename)}`;
        return fetchUrl;
    }
};

// Function to extract the filename from the src URL
export const fetchFileName = (src) => {
    try {
        // Use src.url if present, else src as string
        const raw = (src && typeof src === 'object' && src.url) ? src.url : src;
        let cleanSrc = '';

        try {
            cleanSrc = raw.split('?')[0]; // Remove query params
        } catch (splitErr) {
            console.error("❌ split failed for src:", raw, splitErr);
            return '';
        }

        // Support absolute and relative source URLs.
        const url = new URL(cleanSrc, 'https://vxi.com');
        const segments = url.pathname.split('/');
        const fullFileName = segments.pop() || ''; // e.g. "file_name_abc123.jpg"

        if (!fullFileName || !fullFileName.includes('.')) {
            return '';
        }

        // Handle filenames that contain multiple dots.
        const dotIndex = fullFileName.lastIndexOf('.');
        const namePart = fullFileName.slice(0, dotIndex);
        const extension = fullFileName.slice(dotIndex + 1);

        if (!namePart || !extension) {
            return '';
        }

        return `${namePart}/${namePart}.${extension}`; // Final filename
    } catch (err) {
        console.error("❌ Error extracting filename from src:", err);
        return '';
    }
};

